/**
 * FR-017 — what to tell the farmer when a link write is refused, in the
 * active language (`twinLinks.errors`).
 *
 * Most refusals are ours to prevent (the forms gate the date, offer only
 * anchorless types). One is not knowable up front: `ownership` is an entity
 * relationship, and an event's object page cannot know it is an event — the
 * backend derives the kind — so the refusal is named instead of reading as a
 * generic failure.
 */
import i18n from '../../i18n';

interface RefusalDetail {
  error_kind?: string;
  errors?: Array<{ code?: string; field?: string }>;
}

/**
 * The refusal codes the farmer reads by name. The two line codes (FR-017 #5) are
 * the server's check against the document's rows at write time: the rows can
 * change under an open form (a reprocess re-extracts them), which no gate in
 * the form can see coming. `target_kind_not_allowed` also covers a `price`
 * aimed at an event — prices attach to entities only, and no lens offers an
 * event type today, but the form cannot prove that for every future lens.
 */
const NAMED_CODES = ['anchor_line_missing', 'anchor_line_unidentifiable', 'target_kind_not_allowed'] as const;

export function linkWriteErrorMessage(error: unknown): string {
  const detail = (error as { response?: { data?: { detail?: RefusalDetail } } })?.response?.data?.detail;
  const codes = new Set((detail?.errors ?? []).map((e) => e.code));
  for (const code of NAMED_CODES) {
    if (codes.has(code)) return i18n.t(`twinLinks.errors.${code}`);
  }
  return i18n.t('twinLinks.errors.generic');
}
